import { SuggestedEntry } from 'app/copied/models/ChatModules';
import useNamespacedLocalStorage from 'app/hooks/useNamespacedLocalStorage';

export default function useArticles() {
  const [articles, setArticles] = useNamespacedLocalStorage<SuggestedEntry[]>('tailor-articles', []);

  const addArticle = (article: SuggestedEntry) => {
    const isUnique = !articles.some((existingArticle: SuggestedEntry) => existingArticle.id === article.id);
    if (isUnique) {
      setArticles([...articles, article]);
    }
  };

  return {
    articles,
    addArticle,
  };
}
